import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { useAnalytics } from '@msrceng/analytics';
import { ThanksAndFreeformView } from './ThanksAndFreeformView';
import { FeedbackFivePointMessageBar } from './FeedbackFivePointMessageBar';
import { FivePointRatingActionBar } from './FivePointRatingActionBar';
/**
 * # Five point feedback form (basic)
 * This is a "rate us 1 to 5" feedback component. It shows the
 * user a 1 thru 5 rating scale, where 1 is dissatisfied and 5
 * is satisfied. The user will then be shown input for freeform
 * text feedback. If they complete the form, it displays a thank
 * you message.
 *
 * This specific instance always displays. Use it if you fit one
 * of these use cases:
 * a) want to always show the feedback form to the user.
 * b) want to control the timing yourself.
 *
 * Most developers should look at one of these components with
 * built in timing logic:
 * - `FeedbackFivePointEveryXQuarters`
 * - `FeedbackFivePointEveryXBusinessDays`
 */
export const FeedbackFivePoint = ({ children, source, onComplete, onHide, }) => {
    const [showFeedback, setShowFeedback] = useState(true);
    const [showThanksAfterFreeform, setShowThanksAfterFreeform] = useState(false);
    const [rating, setRating] = useState(undefined);
    const [freeformText, setFreeformText] = useState(undefined);
    const hasRating = rating !== undefined;
    const { appInsights } = useAnalytics();
    const onFeedback = () => {
        appInsights === null || appInsights === void 0 ? void 0 : appInsights.trackEvent({
            name: `FeedbackFivePoint`,
            properties: {
                score: rating,
                source,
                freeform: freeformText,
            },
        });
        setShowThanksAfterFreeform(true);
        onComplete === null || onComplete === void 0 ? void 0 : onComplete();
    };
    const onDismiss = () => {
        appInsights === null || appInsights === void 0 ? void 0 : appInsights.trackEvent({
            name: `FeedbackFivePoint`,
            properties: {
                dismissed: true,
                source,
            },
        });
        setShowFeedback(false);
        onHide === null || onHide === void 0 ? void 0 : onHide();
    };
    if (!showFeedback && !showThanksAfterFreeform) {
        return null;
    }
    if (showThanksAfterFreeform) {
        return (_jsx(MessageBar, Object.assign({ messageBarIconProps: {
                iconName: 'Vacation',
            }, messageBarType: MessageBarType.success, onDismiss: () => setShowThanksAfterFreeform(false), dismissButtonAriaLabel: 'Dismiss' }, { children: "Thank you so much for your input! We'll review this feedback and work on improving the portal." })));
    }
    return (_jsxs(FeedbackFivePointMessageBar, Object.assign({ onDismissFreeform: onDismiss }, { children: [children, _jsx(FivePointRatingActionBar, { rating: rating, onSelectRatingNumber: setRating }), hasRating && (_jsx(ThanksAndFreeformView, { rating: rating, onChange: (_e, newValue) => {
                    setFreeformText(newValue);
                }, onSendFreeform: () => onFeedback(), value: freeformText || '' }))] })));
};
